export function ft_convertRight(newRightName: string) {
	return {
		self: {
			login: newRightName !== 'Aucun',
			read:  newRightName !== 'Aucun',
			edit:  newRightName !== 'Aucun'
		},

		company: {
			read:   newRightName.toLowerCase().includes('admin'),
			edit:   newRightName.toLowerCase().includes('admin'),
			delete: newRightName.toLowerCase().includes('admin')
		},

		companyUsers: {
			read:   newRightName.toLowerCase().includes('admin'),
			edit:   newRightName.toLowerCase().includes('admin'),
			delete: newRightName.toLowerCase().includes('admin')
		}
	};
}